import { useCallback, useEffect, useState } from "react";

// Полный контроль над таймером:

// start() - запускает таймер

// pause() - ставит на паузу

// resume() - продолжает с места остановки

// reset() - полностью сбрасывает таймер

// Состояния:

// timeLeft - оставшееся время в секундах

// isFinished - флаг завершения таймера

// isRunning - флаг работы таймера

// Колбэк onFinish вызывается при завершении таймера

const useTimer = (initialTime, onFinish) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isFinished, setIsFinished] = useState(false);
  const [isRunning, setIsRunning] = useState(false);

  const start = useCallback(() => {
    setIsRunning(true);
    setIsFinished(false);
  }, []);

  const pause = useCallback(() => {
    setIsRunning(false);
  }, []);

  const resume = useCallback(() => {
    setIsRunning(true);
  }, []);

  const reset = useCallback(() => {
    setIsRunning(false);
    setTimeLeft(initialTime);
    setIsFinished(false);
  }, [initialTime]);

  useEffect(() => {
    if (!isRunning || isFinished) return;

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerId);
          setIsFinished(true);
          setIsRunning(false);
          onFinish?.();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [isRunning, isFinished, onFinish]);

  return {
    timeLeft,
    isFinished,
    isRunning,
    start,
    pause,
    resume,
    reset,
  };
};

export default useTimer;
